import { Card, Col, Row, Button, Typography } from "antd";
import { useHistory } from "react-router-dom";
import { StudentNotification } from "interfaces/students";
import axios from "axios";
import RibbonBadge from "./RibbonBadge";

interface Props {
  notification: StudentNotification;
}

const NotificationBox: React.FC<Props> = ({ notification }) => {
  const history = useHistory();
  const { Text } = Typography;
  const date = new Date(notification.created_at);

  return (
    <RibbonBadge read_at={notification.read_at}>
      <Card style={{ marginBottom: ".8em" }}>
        <Row gutter={[10, 10]} style={{ height: "100%", alignItems: "center" }}>
          <Col sm={4} xs={24} style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Text>{date.toLocaleDateString()}</Text>
          </Col>
          <Col sm={16} xs={24} style={{ display: "flex", alignItems: "center", height: "100%" }}>
            {notification.text}
          </Col>
          <Col span={4} style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                history.push(notification.url);
                if (!notification.read_at) {
                  axios.post(`/students/student-notifications/${notification.id}/read/`);
                }
              }}
            >
              Se mer
            </Button>
          </Col>
        </Row>
      </Card>
    </RibbonBadge>
  );
};

export default NotificationBox;
